import constants from 'common/constants'

import {ONBOARDING_TIMETABLE_PREFILL} from './ActionTypes/ApiActionTypes'

/**
 * GET timetable/prefill?countryCode=…&curriculum=… — everything the wizard can pre-fill for a
 * country + curriculum: working/half days, academic session, and per level its grades, school
 * timings, lecture length, breaks, periods per day and subjects with a weekly frequency, plus a
 * `sources` block saying where each group came from. `curriculum` is optional (country-only
 * structure and timings). An unknown curriculum code is a 400 on purpose — never fall back to a
 * prefill the school did not choose. See docs/curriculum-prefill-frontend-integration.md.
 *
 * `plainNames` adds `plain_names=true`: level and grade names come back as the curriculum uses
 * them ("Primary", "Grade 1") instead of prefixed with its short code ("FBISE Primary"). Only
 * for a school whose backend stores the curriculum on each level (see the wizard's
 * utils/levelCurriculum.ts).
 *
 * @param {{countryCode?: string | null; curriculum?: string | null; plainNames?: boolean}} params
 */
export const getTimetablePrefill = (params, onSuccess, onFailure) => {
  const query = new URLSearchParams()
  if (params?.countryCode) query.set('countryCode', params.countryCode)
  if (params?.curriculum) query.set('curriculum', params.curriculum)
  if (params?.plainNames) query.set('plain_names', 'true')
  const getString = query.toString()
  return {
    type: ONBOARDING_TIMETABLE_PREFILL,
    payload: {
      apiUrl: constants.api_timetable_prefill,
      getString: getString ? `?${getString}` : '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      body: null,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
